import React from "react";
import {Card} from "../../../../../components/card/card.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";

const AttendanceObservationsCard = ({form, onChangeField}) => (
    <Card>
        <Card.Header>
            <Card.Title>Observações</Card.Title>
        </Card.Header>
        <Card.Body>
            <SentryRow>
                <InputTextarea
                    className="col-span-12 md:col-span-6"
                    id="observation"
                    label="Observação do atendente"
                    value={form.observation}
                    textAreaClass="h-25!"
                    onChange={({target}) => onChangeField("observation", target.value)}
                />
                <InputTextarea
                    className="col-span-12 md:col-span-6"
                    id="observationFinal"
                    label="Observação final"
                    value={form.observationFinal}
                    textAreaClass="h-25!"
                    onChange={({target}) => onChangeField("observationFinal", target.value)}
                />
            </SentryRow>
        </Card.Body>
    </Card>
);

export default AttendanceObservationsCard;
